module.exports = __webpack_public_path__ + "static/img/68106B_1_V_20201120_LC.5e9429b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68106B_1_V_20201120_LC.png
// module id = kKa9
// module chunks = 0